/* global Selectize */
import { onPageLoad } from '@/js/modules/page_load';

// Selectize plugins register when this module is imported, which is before any ready handler
// builds a selectize, and again after a Turbo visit, whose re-run CDN Selectize script comes back
// without plugins. Callers import the plugin's name constant, so the dependency is explicit.

// Keeps a "new" option in the results when a search matches nothing.
export const SEARCH_DEFAULT_RESULT = 'search_default_result';

onPageLoad(() => {
  if (typeof Selectize !== 'undefined') {
    Selectize.define(SEARCH_DEFAULT_RESULT, function (options) {
      const self = this;
      this.search = (() => {
        const original = self.search;
        const options = self.options;
        return function (...args) {
          const result = original.apply(this, args);
          if (result.items.length < 1 && options.new) {
            result.items.push({ score: 1, id: 'new' });
            result.total = 1;
          }
          return result;
        };
      })();
    });
  }
});
